import context from "@helpers/context"
import { Context } from "../types"

const [
    TableContext,
    useTableContext
] = context<Context>()

export default TableContext
export { useTableContext }